import React from 'react';
import './Faq_main.css'

function Faq_main() {
	return (
		<div>
			<section>
				<div className="container">
					<div className="row">
						<div className="col-md-8">
							<div data-v-45df4330="" data-v-46c7ea73="" className="faq-content " data-v-a46bbb88="">
								<div data-v-45df4330="" className="mb-i">
									<h2 data-v-45df4330="" className="faq-content__title" 	style={{ borderBottom: '1px solid #e35760' }}>
										<p className='mb-1'>
											1. About MNFTSwap
										</p>
									</h2>
									<hr data-v-45df4330="" className="faq-content__separator" />
									<div data-v-45df4330="" id="what-is-swapspace" className="mb-3">
										<h3 data-v-45df4330="" className="faq-content__topic">
											What is MNFTSwap?
										</h3>
										<p data-v-45df4330="" className="faq-content__text-answer">MNFTSwap is an instant cryptocurrency exchange aggregator that allows exchanging over
											900
											cryptocurrencies with fixed and floating rates without limits, registration, or additional fees.
										</p>
									</div>
									<div data-v-45df4330="" id="how-does-swapspace-work" className="mb-3">
										<h3 data-v-45df4330="" className="faq-content__topic">
											How does MNFTSwap work?
										</h3>
										<p data-v-45df4330="" className="faq-content__text-answer">MNFTSwap collects the rates from many instant cryptocurrency instant cryptocurrency swap services providing the opportunity to choose the most profitable option without searching on and comparing many websites. It offers over
											900
											cryptocurrencies for exchange, doesn’t set up extra fees, and doesn't require any personal data from its customers.
										</p>
									</div>
									<div data-v-45df4330="" id="need-registration" className="mb-3">
										<h3 data-v-45df4330="" className="faq-content__topic">
											Do I need to register to use MNFTSwap?
										</h3>
										<div data-v-45df4330="" className="faq-content__text-answer">
											<p>No, you don’t have to create an account or provide any personal info to perform a swap.</p>
										</div>
									</div>
									<div data-v-45df4330="" id="why-should-i-trust-swapspace" className="mb-3">
										<h3 data-v-45df4330="" className="faq-content__topic">
											Why should I trust MNFTSwap?
										</h3>
										<div data-v-45df4330="" className="faq-content__text-answer">
											<p>MNFTSwap is based on the most trustful instant cryptocurrency instant cryptocurrency swap services worldwide. As a non-custodial exchange, it doesn’t store your funds, which eliminates the custodial risks. Read more about <a href="https://swapspace.co/blog/why-swapspace" target="_blank">how we work</a> on our blog.</p>
										</div>
									</div>
									<div data-v-45df4330="" id="swap-space-fee" className="mb-3">
										<h3 data-v-45df4330="" className="faq-content__topic">
											What is MNFTSwap’s fee?
										</h3>
										<div data-v-45df4330="" className="faq-content__text-answer">
											<p>MNFTSwap charges no fee from its customers sharing the commissions with the exchange providers instead. That means you will never pay more than you would pay directly to the integrated services. The conversion rate you see includes all the exchange fees. Note: This fee does not include the miner fee (network commission).</p>
										</div>
									</div>
									<div data-v-45df4330="" id="i-make-profit" className="mb-3">
										<h3 data-v-45df4330="" className="faq-content__topic">
											How can I make profit with MNFTSwap?
										</h3>
										<div data-v-45df4330="" className="faq-content__text-answer">
											<p>MNFTSwap offers two ways to earn a profit via its <a href="https://swapspace.co/affiliate" target="_blank">Affiliate Program</a>. You can share a referral link with your friends or subscribers or integrate us into your service via API. In both cases, you will get 50% of our share.</p>
										</div>
									</div>
									<div data-v-45df4330="" id="i-can-buy" className="mb-3">
										<h3 data-v-45df4330="" className="faq-content__topic">
											How can I buy cryptocurrency with a credit card on MNFTSwap?
										</h3>
										<div data-v-45df4330="" className="faq-content__text-answer">
											<p>You can buy cryptocurrency with fiats via our partner Mercuryo. Choose the fiat currency on the exchange widget on the main page and follow the instructions.</p>
										</div>
									</div>
								</div>
								<div data-v-45df4330="" className="mb-i">
									<h2 data-v-45df4330="" className="faq-content__title" style={{ borderBottom: '1px solid #e35760' }}>
										<p>
										2. Exchange process
										</p>
									</h2>
									<hr data-v-45df4330="" className="faq-content__separator" />
									<div data-v-45df4330="" id="what-is-minimum-amount" className="mb-3">
										<h3 data-v-45df4330="" className="faq-content__topic">
											What is minimum amount?
										</h3>
										<div data-v-45df4330="" className="faq-content__text-answer">
											<p>The minimal amount varies from coin to coin starts from about 2 to 20 dollars for many coins. This is a necessary step to cover the network fees.</p>
										</div>
									</div>
									<div data-v-45df4330="" id="what-is-the-maximum-amount" className="mb-3">
										<h3 data-v-45df4330="" className="faq-content__topic">
											What is the maximum amount?
										</h3>
										<div data-v-45df4330="" className="faq-content__text-answer">
											<p>MNFTSwap doesn’t have upper limits on the amount of coins to be exchanged. You can exchange as many coins as you want!</p>
										</div>
									</div>
									<div data-v-45df4330="" id="how-long-does-it-take" className="mb-3">
										<h3 data-v-45df4330="" className="faq-content__topic">
											How long does it take to exchange coins?
										</h3>
										<div data-v-45df4330="" className="faq-content__text-answer">
											<p>Usually transactions take from 5 to 60 minutes depending on the blockchain capacity. Most of the exchanges are processed within a couple of minutes. If the transaction is large or the blockchain is overloaded, it may take a little longer depending on its size.</p>
										</div>
									</div>
									<div data-v-45df4330="" id="takes-too-long" className="mb-3">
										<h3 data-v-45df4330="" className="faq-content__topic">
											My transaction takes too long. What should I do?
										</h3>
										<div data-v-45df4330="" className="faq-content__text-answer">
											<p>Sometimes the transaction time may be longer than usual. It may happen due to blockchain overload, DDoS attack on the exchange, or cryptocurrency updates. If you have any questions about your transaction, feel free to contact the support via online chat or <a href="mailto:support@swapspace.co">email</a>.</p>
										</div>
									</div>
									<div data-v-45df4330="" id="go-through-kyc" className="mb-3">
										<h3 data-v-45df4330="" className="faq-content__topic">
											Will I have to go through KYC?
										</h3>
										<div data-v-45df4330="" className="faq-content__text-answer">
											<p>MNFTSwap doesn’t have a mandatory pre-KYC procedure itself. That means you can exchange your coins without the need to register and provide your personal data. However, in case our partners’ risk management systems detect a red flag, they can require a selective KYC check.</p>
										</div>
									</div>
									<div data-v-45df4330="" id="the-initial-amount" className="mb-3">
										<h3 data-v-45df4330="" className="faq-content__topic">
											Why the amount I received is different from the initial amount?
										</h3>
										<div data-v-45df4330="" className="faq-content__text-answer">
											<p>Due to the volatility of cryptocurrency, the exchange rate may fluctuate while our partners are processing the transaction. It can lead to both positive or negative changes in the final amount of cryptocurrency you receive in the wallet.</p>
										</div>
									</div>
									<div data-v-45df4330="" id="floating-rate-exchange?" className="mb-3">
										<h3 data-v-45df4330="" className="faq-content__topic">
											What is a floating rate exchange?
										</h3>
										<div data-v-45df4330="" className="faq-content__text-answer">
											<p>Due to cryptocurrency market volatility, the exchange rates may change during the exchange. Choosing the floating, or classNameic, exchange rate, you need to know that the rates may change at any moment, and you might receive more or fewer coins that you had been expecting.</p>
										</div>
									</div>
									<div data-v-45df4330="" id="fixed-rate-exchange?" className="mb-3">
										<h3 data-v-45df4330="" className="faq-content__topic">
											What is a fixed rate exchange?
										</h3>
										<div data-v-45df4330="" className="faq-content__text-answer">
											<p>If you create a fixed rate exchange, the exchange service will freeze the rates for some time to help you to escape the rate fluctuations. You will have from 15 to 120 minutes to deposit your funds depending on the exchange service you chose. You will receive the estimated amount at the end.</p>
										</div>
									</div>
									<div data-v-45df4330="" id="floating-exchange-rates" className="mb-3">
										<h3 data-v-45df4330="" className="faq-content__topic">
											What is the difference between fixed and floating exchange rates?
										</h3>
										<div data-v-45df4330="" className="faq-content__text-answer">
											<p>During the floating rate exchange, the exchange rate may vary in accordance with the market fluctuations, and the amount of coins you receive in the wallet may be a bit more or less than the expected one.</p>
											<p>During the fixed rate exchange, the rates are fixed by the exchanger for some time so you could avoid the price shifts and receive the exact amount you expected. The rate may vary with the floating one because the risks are already included in the price.</p>
										</div>
									</div>
									<div data-v-45df4330="" id="do-cancel-transaction?" className="mb-3">
										<h3 data-v-45df4330="" className="faq-content__topic">
											How do I cancel my transaction?
										</h3>
										<div data-v-45df4330="" className="faq-content__text-answer">
											<p>Blockchain transactions are irreversible. Once the funds are sent, you can’t cancel it anymore. Be careful and double-check all the payment details before sending cryptocurrency to us or anyone else.</p>
										</div>
									</div>
									<div data-v-45df4330="" id="is-transaction-hash" className="mb-3">
										<h3 data-v-45df4330="" className="faq-content__topic">
											What is the transaction hash?
										</h3>
										<div data-v-45df4330="" className="faq-content__text-answer">
											<p>Transaction hash is a unique set of characters that is given to every transaction in the blockchain. It allows you to check the transaction status.</p>
										</div>
									</div>
								</div>
								<div data-v-45df4330="" className="mb-i">
									<h2 data-v-45df4330="" className="faq-content__title" style={{ borderBottom: '1px solid #e35760' }}>
										<p>
										3. Wallet
										</p>
									</h2>
									<hr data-v-45df4330="" className="faq-content__separator" />
									<div data-v-45df4330="" id="my-wallet-address" className="mb-3">
										<h3 data-v-45df4330="" className="faq-content__topic">
											What is a wallet address?
										</h3>
										<div data-v-45df4330="" className="faq-content__text-answer">
											<p>A cryptocurrency wallet is a digital place to manage your coins or tokens. The wallet address implies a unique combination of numbers and letters, usually from 26 to 35 characters, that represents a possible destination of the payment. It may look like&nbsp;this: 0x89205A3A3b2A69De7.</p>
											<br />
											<p>To create an exchange on MNFTSwap, you need to provide a pre-existing wallet address. Read more about <a href="" target="_blank">how to get a wallet</a> in our blog.</p>
										</div>
									</div>
									<div data-v-45df4330="" id="get-wallet-address" className="mb-3">
										<h3 data-v-45df4330="" className="faq-content__topic">
											How do I get a wallet address?
										</h3>
										<div data-v-45df4330="" className="faq-content__text-answer">
											<p>Choose the coin you want to buy or sell, then find a stable and proven service and register there to get a wallet. Usually, every coin has an official wallet client.</p>
										</div>
									</div>
									<div data-v-45df4330="" id="the-recipient-address?" className="mb-3">
										<h3 data-v-45df4330="" className="faq-content__topic">
											What is the recipient’s address?
										</h3>
										<div data-v-45df4330="" className="faq-content__text-answer">
											<p>The recipient’s address is an address that you provide to the exchange service as a destination address. It means the output transaction will go from the exchange service to this address. For example, if you want to buy Dogecoin (DOGE), you should specify a DOGE wallet address in the recipient field. Then swap service will send the coins to this address once the transaction is complete.</p>
										</div>
									</div>
								</div>
							</div>
						</div>
						{/* <div class="col-md-4">
			        		<button class="accordion">About MNFTSwap</button>
								<div class="panel">
								  <p>What is MNFTSwap?</p>
								  <p>How does MNFTSwap work?</p>
								  <p>Do I need to register to use MNFTSwap?</p>
								  <p>Why should I trust MNFTSwap?</p>
								  <p>What is MNFTSwap’s fee?</p>
								  <p>How can I make profit with MNFTSwap?</p>
								  <p>How can I buy cryptocurrency with a credit card on MNFTSwap?</p>
								</div>

								<button class="accordion">Exchange process</button>
								<div class="panel">
								  <p>What is minimum amount?</p>
								  <p>What is the maximum amount?</p>
								  <p>How long does it take to exchange coins?</p>
								  <p>My transaction takes too long. What should I do?</p>
								  <p>Will I have to go through KYC?</p>
								  <p>Why the amount I received is different from the initial amount?</p>
								  <p>What is a floating rate exchange?</p>
								  <p>What is a fixed rate exchange?</p>
								  <p>What is the difference between fixed and floating exchange rates?</p>
								  <p>How do I cancel my transaction?</p>
								  <p>What is the transaction hash?</p>
								  
								</div>


								<button class="accordion">Wallet</button>
								<div class=""></div>
								<div class="panel">
								  <p>What is a wallet address?</p>
								  <p>How do I get a wallet address?</p>
								  <p>What is the recipient’s address?</p>
								</div>
								<br/>

								<p><i>If you can't find the answer to your question, drop an email to support@swapspace.co. MNFTSwap support team is always happy to help you.</i></p>

								
			        	</div> */}

						<div className="col-md-4">
							<div className="accordion" id="accordionPanelsStayOpenExample">
								<div className="accordion-item">
									<h2 className="accordion-header" id="panelsStayOpen-headingOne">
										<button
											className="accordion-button"
											type="button"
											data-bs-toggle="collapse"
											data-bs-target="#panelsStayOpen-collapseOne"
											aria-expanded="true"
											aria-controls="panelsStayOpen-collapseOne"
										>
											About MNFTSwap
										</button>
									</h2>
									<div
										id="panelsStayOpen-collapseOne"
										className="accordion-collapse collapse show"
									// aria-labelledby="panelsStayOpen-headingOne"
									>
										<div className="accordion-body">
											<div class="list">
												<p>What is MNFTSwap?</p>
												<p>How does MNFTSwap work?</p>
												<p>Do I need to register to use MNFTSwap?</p>
												<p>Why should I trust MNFTSwap?</p>
												<p>What is MNFTSwap’s fee?</p>
												<p>How can I make profit with MNFTSwap?</p>
												<p>How can I buy cryptocurrency with a credit card on MNFTSwap?</p>
											</div>
										</div>
									</div>
								</div>
								<div className="accordion-item">
									<h2 className="accordion-header" id="panelsStayOpen-headingTwo">
										<button
											className="accordion-button collapsed"
											type="button"
											data-bs-toggle="collapse"
											data-bs-target="#panelsStayOpen-collapseTwo"
											aria-expanded="false"
											aria-controls="panelsStayOpen-collapseTwo"
										>
											Exchange Process
										</button>
									</h2>
									<div
										id="panelsStayOpen-collapseTwo"
										className="accordion-collapse collapse"
										aria-labelledby="panelsStayOpen-headingTwo"
									>
										<div className="accordion-body">
											<div class="">
												<p>What is minimum amount?</p>
												<p>What is the maximum amount?</p>
												<p>How long does it take to exchange coins?</p>
												<p>My transaction takes too long. What should I do?</p>
												<p>Will I have to go through KYC?</p>
												<p>Why the amount I received is different from the initial amount?</p>
												<p>What is a floating rate exchange?</p>
												<p>What is a fixed rate exchange?</p>
												<p>What is the difference between fixed and floating exchange rates?</p>
												<p>How do I cancel my transaction?</p>
												<p>What is the transaction hash?</p>

											</div>
										</div>
									</div>
								</div>
								<div className="accordion-item">
									<h2 className="accordion-header" id="panelsStayOpen-headingThree">
										<button
											className="accordion-button collapsed"
											type="button"
											data-bs-toggle="collapse"
											data-bs-target="#panelsStayOpen-collapseThree"
											aria-expanded="false"
											aria-controls="panelsStayOpen-collapseThree"
										>
											Wallet
										</button>
									</h2>
									<div
										id="panelsStayOpen-collapseThree"
										className="accordion-collapse collapse"
										aria-labelledby="panelsStayOpen-headingThree"
									>
										<div className="accordion-body">
											<div class="">
												<p>What is a wallet address?</p>
												<p>How do I get a wallet address?</p>
												<p>What is the recipient’s address?</p>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>



				</div>
			</section>
		</div>
	)
}

export default Faq_main
